import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "bin",
  "description": "`turbo bin` 命令的 API 参考"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "获取 turbo 二进制文件的路径。"
  }, {
    "heading": "",
    "content": "¥Get the path to the turbo binary."
  }, {
    "heading": "",
    "content": "使用 全局 turbo 时，这将是全局 turbo 二进制文件的路径。你可能会看到用于安装 turbo 的包管理器的全局目录路径。"
  }, {
    "heading": "",
    "content": "¥When using global turbo, this will be the path to the global turbo binary. You're likely to see a path to the global directory of the package manager you used to install turbo."
  }, {
    "heading": "",
    "content": "使用 本地 turbo 时，这将是本地 turbo 二进制文件的路径。当 turbo 安装在你的仓库中时，它很可能是指向 node_modules 的路径。"
  }, {
    "heading": "",
    "content": "¥When using local turbo, this will be the path to the local turbo binary. When turbo is installed in your repository, it is likely to be a path to node_modules."
  }],
  "headings": []
};
export const toc = [];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    p: "p",
    pre: "pre",
    span: "span",
    strong: "strong",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.p, {
      children: ["获取 ", _jsx(_components.code, {
        children: "turbo"
      }), " 二进制文件的路径。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Get the path to the ", _jsx(_components.code, {
        children: "turbo"
      }), " binary."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " bin"
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["使用 ", _jsx(_components.a, {
        href: "/docs/getting-started/installation#global-installation",
        children: _jsxs(_components.strong, {
          children: ["全局 ", _jsx(_components.code, {
            children: "turbo"
          })]
        })
      }), " 时，这将是全局 ", _jsx(_components.code, {
        children: "turbo"
      }), " 二进制文件的路径。你可能会看到用于安装 ", _jsx(_components.code, {
        children: "turbo"
      }), " 的包管理器的全局目录路径。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥When using ", _jsx(_components.a, {
        href: "/docs/getting-started/installation#global-installation",
        children: _jsxs(_components.strong, {
          children: ["global ", _jsx(_components.code, {
            children: "turbo"
          })]
        })
      }), ", this will be the path to the global ", _jsx(_components.code, {
        children: "turbo"
      }), " binary. You're likely to see a path to the global directory of the package manager you used to install ", _jsx(_components.code, {
        children: "turbo"
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: ["使用 ", _jsx(_components.a, {
        href: "/docs/getting-started/installation#repository-installation",
        children: _jsxs(_components.strong, {
          children: ["本地 ", _jsx(_components.code, {
            children: "turbo"
          })]
        })
      }), " 时，这将是本地 ", _jsx(_components.code, {
        children: "turbo"
      }), " 二进制文件的路径。当 ", _jsx(_components.code, {
        children: "turbo"
      }), " 安装在你的仓库中时，它很可能是指向 ", _jsx(_components.code, {
        children: "node_modules"
      }), " 的路径。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥When using ", _jsx(_components.a, {
        href: "/docs/getting-started/installation#repository-installation",
        children: _jsxs(_components.strong, {
          children: ["local ", _jsx(_components.code, {
            children: "turbo"
          })]
        })
      }), ", this will be the path to the local ", _jsx(_components.code, {
        children: "turbo"
      }), " binary. When ", _jsx(_components.code, {
        children: "turbo"
      }), " is installed in your repository, it is likely to be a path to ", _jsx(_components.code, {
        children: "node_modules"
      }), "."]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
